module.exports = __webpack_public_path__ + "static/media/bg-barn-color.7bee8390.png";